import styled from 'styled-components';
import { FlexColumn, FlexRow, Text } from '@make-software/tg-mini-app-ui';

export const StatusArea = styled.div(({ theme }) =>
  theme.withMedia({
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    backgroundColor: theme.colors.cardBg,
    border: `1px solid ${theme.colors.border}`,
    padding: '8px 16px',
    width: '100%'
  })
);

export const StyledTitle = styled.div(({ theme }) =>
  theme.withMedia({
    color: theme.colors.mainGray,
    fontSize: '12px',
    fontWeight: 400,
    fontFamily: theme.typography.fontFamily.sans
  })
);

export const StyledContentRow = styled(FlexRow)(({ theme }) =>
  theme.withMedia({
    color: theme.colors.contentPrimary,
    svg: {
      marginBottom: '4px'
    }
  })
);

export const StyledBalanceRow = styled(FlexRow)(({ theme }) =>
  theme.withMedia({
    margin: '16px 0'
  })
);

export const StyledBalance = styled(Text)(({ theme }) =>
  theme.withMedia({
    color: theme.colors.lightGray,
    fontSize: '18px',
    fontFamily: theme.typography.fontFamily.display,
    fontWeight: 300,
    lineHeight: '140%'
  })
);

export const ImageRow = styled(FlexRow)(({ theme }) =>
  theme.withMedia({
    marginBottom: '25px',
    width: '100%',
    height: 0,
    paddingBottom: 'calc(0.5 * 100%)',
    position: 'relative',
    border: `1px solid ${theme.colors.border}`
  })
);

export const StyledBanner = styled.img(({ theme }) =>
  theme.withMedia({
    position: 'absolute',
    top: '0',
    left: '0',
    width: '100%',
    height: '100%',
    objectFit: 'cover'
  })
);

export const StyledBodyText = styled(Text)(({ theme }) =>
  theme.withMedia({
    fontWeight: '700',
    color: theme.colors.mainWhite,
    fontSize: '18px',
    fontFamily: theme.typography.fontFamily.display,
    marginBottom: '8px'
  })
);

export const HackathonProjectList = styled(FlexColumn)(({ theme }) =>
  theme.withMedia({
      padding: '1rem 1.0625rem',
      gap: '0.75rem',
      backgroundColor: '#1C1D24',
      alignItems: 'flex-start'
  })
);
